// extracted by mini-css-extract-plugin
export default {"pgWrapper":"ProgressStep_pgWrapper__+lcbS","pgDot":"ProgressStep_pgDot__mjgHD","active":"ProgressStep_active__fZHvm"};